<script setup>
  import { defineProps, ref } from 'vue'
  import { useTerritoriosStore } from "@/store/territorios";
  const territorios = useTerritoriosStore();

  const props = defineProps({
    zona: {
      type: String,
      default: null
    },
    numero: {
      type: String,
      default: null
    },
    puntosEncuentro: {
      type: Array,
      default: []
    }
  })

  const item = ref(null)

  setTimeout(() => {
    const puntoEncuentro = props.puntosEncuentro?.filter(p => p.hasOwnProperty('index')) || []
    console.log("getTerritorio", props)
    item.value = {
      ...territorios.getTerritorio(props.zona, props.numero),
      puntoEncuentro
    }
  }, 1000)

  
</script>

<template>
  <div v-if="item">
    <!-- {{ item }} -->
    <iframe :src="'/mapa.html?center='+item.center+'&puntoEncuentroIndex='+JSON.stringify(item.puntoEncuentro)+'&zoom='+item.zoom+'&limits='+JSON.stringify(item.limits)+'&mzNumbers='+JSON.stringify(item.mzNumbers)" frameborder="0" id="map-iframe"></iframe>
  </div>
</template>

<style scoped>

 #map-iframe {
   width: 100%;
   min-height: 80vh;
 }
</style>